// - Fast convert string to number
// - Passes through number values
// - Boolean values return 1 or 0
// - Null return 0
// - Empty or whitespace strings return 0
// - Non-numeric strings, non-string & non-numeric types, undefined return default value

export const mapToNumber = (value: any, defaultValue: number): number => {
  const r = +value;
  return isNaN(r) ? defaultValue : r;
};
